import { combineReducers } from 'redux';
import application from './application';

export default combineReducers({
    application
   });